import { SearchOverlay } from './Components/SearchOverlay';

window.addEventListener('DOMContentLoaded', () => {
    new SearchOverlay();
});